import { t } from '@lingui/core/macro';
import { VStack } from '@chakra-ui/react';

import { djs } from '@duke-hq/djs';
import { trpcTenant } from '@duke-hq/app-provider-web/tenant/trpcTenant';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { StudentEnrolmentHealth } from '@duke-hq/svc-api-db';

import buildLinkToEnrolments from '../../utils/buildLinkToEnrolments';
import ContentContainer from './shared/ContentContainer';
import ProgressBarCard from './shared/ProgressBarCard';
import SidePanelContentHeader from './shared/ContentHeader';
import NoDataMessage from './shared/NoDataMessage';

const healthFilters = [
  StudentEnrolmentHealth.NOT_STARTED,
  StudentEnrolmentHealth.BEHIND,
  StudentEnrolmentHealth.SLIPPING,
  StudentEnrolmentHealth.ON_TRACK,
];

function DueNextMonthWithData() {
  const { filters } = useFiltersContext();
  const { data } = trpcTenant.dashboard.getDueNextMonth.useQuery({ filters }, { suspense: true });

  if (!data || data.length === 0) {
    return <NoDataMessage />;
  }

  return (
    <>
      <SidePanelContentHeader
        title={t`Health`}
        tooltipText={t`Health of participants due for semester completion in the next 4 weeks`}
        to={buildLinkToEnrolments({
          dueDateStart: djs.utc(),
          dueDateEnd: djs.utc().add(28, 'days'),
          health: healthFilters,
        })}
      />

      <VStack spacing={2} align="flex-start">
        {data.map(({ range, total, data, startDate, endDate }) => (
          <ProgressBarCard
            key={range}
            title={range}
            total={total}
            data={data}
            to={buildLinkToEnrolments({
              dueDateStart: djs.utc(startDate),
              dueDateEnd: djs.utc(endDate),
              health: healthFilters,
            })}
          />
        ))}
      </VStack>
    </>
  );
}

export default function DueNextMonth() {
  return (
    <ContentContainer title={t`Next 4 weeks`}>
      <DueNextMonthWithData />
    </ContentContainer>
  );
}
